/**
 * Closing tab → Closing Documents: the focused upload section for the
 * funding-gating closing documents (closing-readiness.md §3b). Files land on
 * the loan's normal document store; after an upload or a compare the loan is
 * refetched so the Documents tab and the readiness signal both catch up.
 */
import { useCallback, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import PrimaryContentCard from "../../../../_src_shared/components/layout/PrimaryContentCard";
import ClosingDocumentsSection from "../../../../components/closingReadiness/ClosingDocumentsSection";
import { useUnderwritingHook } from "../../../../hooks/useUnderwritingHook";
import { useIsAcquisitions } from "../../../../pipelines/PipelineContext";
import { loanDrilldownSet } from "../../../../redux/actions/loanDrilldownActions";

const LoanClosingSubTabClosingDocs = () => {
  const dispatch = useDispatch();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const isAcquisitions = useIsAcquisitions();
  const { getLoanById } = useUnderwritingHook();
  const dealId = loanDrilldown?._id;
  const [refreshKey, setRefreshKey] = useState(0);

  const onChanged = useCallback(() => {
    if (!dealId) return;
    getLoanById({
      loanId: dealId,
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        setRefreshKey((k) => k + 1);
      },
    });
  }, [dealId, dispatch, getLoanById]);

  return (
    <PrimaryContentCard
      maxWidth={false}
      title={isAcquisitions ? "Settlement documents" : "Closing documents"}
      headerSx={{ pb: 1 }}
    >
      <ClosingDocumentsSection
        dealId={dealId}
        pipeline={isAcquisitions ? "acquisition" : "preclose"}
        loanDocuments={loanDrilldown?.loanDocuments}
        onChanged={onChanged}
        refreshKey={refreshKey}
      />
    </PrimaryContentCard>
  );
};

export default LoanClosingSubTabClosingDocs;
